'use client';
import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            borderBottom: '1px solid #e2e8f0',
          }}
        >
          <button
            onClick={() => toggle(i)}
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 0',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              gap: '16px',
            }}
          >
            <span
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                fontSize: '0.98rem',
                color: '#1a2b4a',
                lineHeight: 1.5,
              }}
            >
              {item.question}
            </span>
            <span
              style={{
                color: '#00b28a',
                fontSize: '1rem',
                flexShrink: 0,
                transition: 'transform 0.3s ease',
                transform: openIndex === i ? 'rotate(180deg)' : 'rotate(0deg)',
                display: 'inline-block',
              }}
            >
              ▾
            </span>
          </button>
          <div
            style={{
              maxHeight: openIndex === i ? '300px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.4s ease',
            }}
          >
            <p
              style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.95rem',
                color: '#4a5568',
                lineHeight: 1.75,
                paddingBottom: '20px',
                margin: 0,
              }}
            >
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
